var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ 'button-atom': true },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.icon)?_c('AtomsCommonAtomIcon',{attrs:{"icon":_vm.icon,"size":14}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }